import { useState } from "react";
import { useFormik } from "formik";
import { FormattedMessage, useIntl } from "react-intl";
import { HandleAddNewStudent } from "../../actions/teacherMutations";
import { Button, Input, Row } from "reactstrap";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { checkNameLengthAndCharacters } from "../../Utilities/checkerFunctions";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

function CreateStudentInClassForm({
  classId,
  toggle,
  toggleAndAddLicense,
  purchaserTeacher,
}) {
  const intl = useIntl();
  const mutateStudentAdd = useMutation({ mutationFn: HandleAddNewStudent });
  const queryClient = useQueryClient();
  const [addStudentLicense, setAddStudentLicense] = useState(false);

  const toggleAddLicense = (event) => {
    setAddStudentLicense(event.target.checked);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
      classId: classId,
    },
    onSubmit: (values) => {
      if (checkNameLengthAndCharacters(values.name) !== true) {
        toast.warn(checkNameLengthAndCharacters(values.name));
      } else {
        mutateStudentAdd.mutate(
          {
            values,
          },
          {
            onSuccess: (data) => {
              toast.success(<FormattedMessage id="StudentCreated" />);
              queryClient.invalidateQueries({ queryKey: ["FetchTeacherInformation"] });
              queryClient.invalidateQueries({ queryKey: ["FetchClassByClassId"] });
              if (addStudentLicense) {
                toggleAndAddLicense(data.data.result);
              } else {
                toggle();
              }
            },
            onError: (err) => {
              toast.warn(formatServiceError(intl, err?.response?.data));
            },
          }
        );
      }
    },
  });
  return (
    <form onSubmit={formik.handleSubmit}>
      <label htmlFor="name">
        <FormattedMessage id="Name" />:
      </label>
      <Input
        id="name"
        name="name"
        type="name"
        onChange={formik.handleChange}
        value={formik.values.name}
      />
      <label className="mt-2" htmlFor="email">
        <FormattedMessage id="Email" />:
      </label>
      <Input
        id="email"
        name="email"
        type="email"
        onChange={formik.handleChange}
        value={formik.values.email}
      />
      <Row lg={12} className="mt-3 ms-0">
        <div className="d-flex align-items-center mb-3">
          <label className="" htmlFor="addLicense">
            <FormattedMessage id="AddLicenseAfterCreate" />:
          </label>
          <div>
            <Input
              id="addLicense"
              name="addLicense"
              className="ms-2 mt-1"
              title={
                !purchaserTeacher
                  ? intl.formatMessage({
                      id: "YouNeedToBePurchaserToBeAbleToAddLicense",
                    })
                  : ""
              }
              type="checkbox"
              disabled={!purchaserTeacher}
              onChange={(event) => toggleAddLicense(event)}
            />
          </div>
        </div>
      </Row>
      <div className="d-flex justify-content-end gap-2">
        <Button
          color="secondary"
          outline
          className="mt-2 float-end"
          type="button"
          onClick={toggle}
        >
          <FormattedMessage id="Cancel" />
        </Button>
        <Button color="primary" outline className="mt-2" type="submit">
          <FormattedMessage id="CreateStudent" />
        </Button>
      </div>
    </form>
  );
}
export default CreateStudentInClassForm;
